import { Alert, AlertTitle, Box, Button, IconButton } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { oidButtonSX } from "../../pages/user/Account/components/IdentitiesTab";
import { BCPXmark } from "../icons/bcp/BCPIcons";
import { GWWarhammerIcon } from "../icons/gw/GWIcons";
import {
  getLocalStorage,
  setLocalStorage
} from "../layout/cookies/CookieFunctions";
import { AuthContext } from "../user/BCPAuthProvider";
import { isAppMode } from "../../global/AppOverlay";

const IS_GW =
  getEnvironmentVariable("IS_GW") === "true" ||
  getEnvironmentVariable("COMPANY_FLAG") === "gw";

export function MyWarhammerLinkButton(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.myWarhammerAlert"
  });
  const authContext = useContext(AuthContext);
  const buttonSX = oidButtonSX("GamesWorkshop");
  const { fullWidth, disabled, target } = props;

  const isAuthenticated = authContext?.authState?.isAuthenticated;
  const buttonText = isAuthenticated
    ? t("linkWithMyWarhammer")
    : t("loginWithMyWarhammer");

  return (
    <Button
      variant="contained"
      color="warning"
      sx={{ textTransform: "unset", mt: 2, ...buttonSX }}
      fullWidth={fullWidth}
      startIcon={<GWWarhammerIcon />}
      href="/account?active_tab=identities"
      disabled={disabled}
      target={target}
    >
      {buttonText}
    </Button>
  );
}

export default function GWMyWarhammerAlert(props) {
  const { authContext } = props;

  const { t } = useTranslation("translation", {
    keyPrefix: "components.myWarhammerAlert"
  });
  const lastDismissed = getLocalStorage("GWMyWarhammerDismissed");

  const hasMyWarhammer = authContext?.authState?.identity?.hasMyWarhammer;
  const appMode = isAppMode();

  const [hidden, setHidden] = useState(
    appMode || lastDismissed || hasMyWarhammer ? true : false
  );

  // If user has dismissed the alert, show it again after 12 hours
  useEffect(() => {
    if (hasMyWarhammer) {
      if (!hidden) setHidden(true);
      return;
    } else if (lastDismissed) {
      const lastDismissedDate = moment(lastDismissed);
      const now = moment();

      if (now.diff(lastDismissedDate, "hours") >= 12) {
        if (hidden) setHidden(false);
      } else {
        if (!hidden) setHidden(true);
      }
    }
  }, [lastDismissed, hidden, hasMyWarhammer]);

  return (
    <>
      {!hidden && (
        <Alert
          icon={false}
          color={IS_GW ? "warning" : "info"}
          sx={{ textAlign: "center", justifyContent: "center" }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{
              position: "absolute",
              top: "60px",
              right: "4px"
            }}
            onClick={() => {
              setLocalStorage("GWMyWarhammerDismissed", moment().toISOString());
              setHidden(true);
            }}
          >
            <BCPXmark />
          </IconButton>
          <AlertTitle sx={{ textTransform: "uppercase" }}>
            {t("title")}
          </AlertTitle>
          {t("description")}
          <Box
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <MyWarhammerLinkButton />
          </Box>
        </Alert>
      )}
    </>
  );
}
